import ReactPaginate from 'react-paginate'
import PropTypes from 'prop-types'
export const Pagination = ({ page, totalPage, onPageChange }) => {
  return (
    <ReactPaginate
      breakLabel='...'
      nextLabel='Siguiente'
      previousLabel='Anterior'
      onPageChange={onPageChange}
      containerClassName='pagy-nav'
      forcePage={page}
      pageClassName='page'
      activeClassName='active'
      previousClassName='page prev'
      nextClassName='page next'
      pageCount={totalPage}
      renderOnZeroPageCount={null}
    />
  )
}

Pagination.propTypes = {
  page: PropTypes.number,
  totalPage: PropTypes.number,
  onPageChange: PropTypes.func
}
